import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ClInputNumber } from '@corelabs/angular/ui';
import { ErrorComponent } from '../error/error.component';

@Component({
    selector: 'app-form-input-number',
    templateUrl: './form-input-number.component.html',
    styleUrls: ['./form-input-number.component.css'],
    imports: [ReactiveFormsModule, ClInputNumber, ErrorComponent],
})
export class FormInputNumberComponent {
    readonly control = input.required<FormControl<number | null>>();
    readonly label = input.required<string>();
    readonly inputId = input.required<string>();
}
